<template>
  <div slot-scope="{ form, methods }" class="space-y-6">

    <vehicles-card :form="form" :methods="methods" />

    <div class="card">
      <div class="card-header">
        Conditions
      </div>
      <div class="p-6">
        <label class="form-label">If the driver has been continously driving for...</label>
        <div class="flex max-w-xs">
          <input type="number" v-model="form.threshold" class="form-input prepend" />
          <div class="form-suffix">kilometres</div>
        </div>
      </div>
    </div>

    <area-card :form="form" :methods="methods" />

    <schedule-card :form="form" :methods="methods" />

    <contacts-card :form="form" :methods="methods" />

    <driver-device-card :form="form" :methods="methods" />
    
    <monitor-card :form="form" :methods="methods" />

  </div>
</template>

<script>
  import AreaCard from '@/views/automations/components/AreaCard'
  import ContactsCard from '@/views/automations/components/ContactsCard'
  import DriverDeviceCard from '@/views/automations/components/DriverDeviceCard'
  import MonitorCard from '@/views/automations/components/MonitorCard'
  import ScheduleCard from '@/views/automations/components/ScheduleCard'
  import VehiclesCard from '@/views/automations/components/VehiclesCard'

  export default {
    name: 'ContinuousDrivingDistance',

    components: { 
      AreaCard,
      ContactsCard,
      DriverDeviceCard,
      MonitorCard,
      ScheduleCard,
      VehiclesCard
    },
    
    props: ['form', 'methods']
  }
</script>